import { render, staticRenderFns } from "./ProtocolPage.vue?vue&type=template&id=7d28e5ed&scoped=true"
import script from "./ProtocolPage.vue?vue&type=script&lang=js"
export * from "./ProtocolPage.vue?vue&type=script&lang=js"
import style0 from "./ProtocolPage.vue?vue&type=style&index=0&id=7d28e5ed&prod&scoped=true&lang=less"
import style1 from "./ProtocolPage.vue?vue&type=style&index=1&id=7d28e5ed&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d28e5ed",
  null
  
)

export default component.exports